var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Default',[_c('div',{staticClass:"ecosystems"},[_c('Discover'),_c('Ecology')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }